/*
 * Dati mancanti o sbagliati in un modulo (regola SUI «Campi da compilare»): niente finestra di avviso.
 * Il campo si evidenzia (riga rossa, etichetta rossa), sotto compare in rosso cosa manca, la pagina scorre
 * e il cursore va sul primo campo. Il segnale sparisce da solo appena si tocca il campo.
 *
 *   const n = segnalaMancanti([
 *     { campo: 'stripe-key', messaggio: 'Manca la chiave privata di Stripe' },
 *     { campo: iban, messaggio: "L'IBAN deve avere 27 caratteri" },   // id, name oppure l'elemento
 *   ]);
 *   if (n > 0) return;   // ci sono dati mancanti: non si salva
 *
 * Il segnale sta in `data-mancante` sul contenitore del campo e `aria-invalid` sul campo: non tocca le classi di React.
 * Lo stile e` in .sid-... `[data-mancante]` (_sportid-design-align.scss).
 */

const CONTROLLI = 'input:not([type=hidden]), select, textarea';

const trova = (campo) => {
    if (!campo) return null;
    if (typeof campo !== 'string') return campo;
    return document.getElementById(campo) || document.querySelector(`[name="${campo}"]`);
};

/** Il contenitore piu` grande che ha dentro solo questo campo (con la sua etichetta). */
const contenitore = (el) => {
    let corrente = el;
    for (let i = 0; i < 5; i += 1) {
        const padre = corrente.parentElement;
        // Si sale finche' nel contenitore c'e' solo questo campo e la sua etichetta (non altri campi, interruttori o etichette)
        // ... e non oltre il corpo di una finestra, dove il messaggio finirebbe sotto tutto il popup invece che sotto il campo
        if (!padre || padre === document.body || padre.classList.contains('modal-body') || padre.classList.contains('modal-content') || padre.querySelectorAll(CONTROLLI).length > 1 || padre.querySelectorAll('label').length > 1) break;
        corrente = padre;
        // Una colonna o un gruppo di campo è già il riquadro giusto: il messaggio sta sotto il campo, non sotto tutta la sezione
        if (/(^|\s)(col(-[a-z]+)?(-\d+)?|form-group|mb-\d)(\s|$)/.test(padre.className || '')) break;
    }
    return corrente === el ? el.parentElement : corrente;
};

export const togliMancante = (campo) => {
    const el = trova(campo);
    if (!el) return;
    el.removeAttribute('aria-invalid');
    contenitore(el)?.removeAttribute('data-mancante');
};

export const segnalaMancanti = (lista) => {
    const trovati = [];
    (lista || []).forEach(({ campo, messaggio }) => {
        const el = trova(campo);
        if (!el) return;
        const wrap = contenitore(el);
        if (!wrap) return;
        wrap.setAttribute('data-mancante', messaggio || 'Dato mancante');
        el.setAttribute('aria-invalid', 'true');
        const pulisci = () => {
            wrap.removeAttribute('data-mancante');
            el.removeAttribute('aria-invalid');
            ['input', 'change', 'click'].forEach((tipo) => wrap.removeEventListener(tipo, pulisci, true));
        };
        ['input', 'change', 'click'].forEach((tipo) => wrap.addEventListener(tipo, pulisci, true));
        trovati.push(el);
    });
    const primo = trovati[0];
    if (primo) {
        primo.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(() => primo.focus({ preventScroll: true }), 200);
    }
    return trovati.length;
};

export default segnalaMancanti;
